import { Link, useLocation } from "react-router-dom";
import { FiHome, FiInfo, FiMail, FiZap, FiUser, FiGrid } from "react-icons/fi";
import { useSession } from "./SessionGuard";

const publicTabs = [
  { label: "Home",        icon: FiHome,  path: "/" },
  { label: "About",       icon: FiInfo,  path: "/about" },
  { label: "Contact",     icon: FiMail,  path: "/contact" },
  { label: "Get Started", icon: FiZap,   path: "/get-started" },
  { label: "Sign In",     icon: FiUser,  path: "/login" },
];

const privateTabs = [
  { label: "Home",      icon: FiHome,  path: "/" },
  { label: "Dashboard", icon: FiGrid,  path: "/dashboard" },
  { label: "About",     icon: FiInfo,  path: "/about" },
  { label: "Contact",   icon: FiMail,  path: "/contact" },
  { label: "Profile",   icon: FiUser,  path: "/profile" },
];

export default function BottomTabBar() {
  const location = useLocation();
  const session = useSession();
  const isLoggedIn = !!session?.user;
  const tabs = isLoggedIn ? privateTabs : publicTabs;
  const isActive = (path) => location.pathname === path;

  return (
    <nav style={styles.nav} className="bottom-tab-bar-mobile-only">
      {tabs.map(({ label, icon: Icon, path }) => {
        const active = isActive(path);
        return (
          <Link key={path} to={path} style={styles.tab}>
            <Icon
              size={22}
              strokeWidth={active ? 2.5 : 1.8}
              color={active ? "var(--soil-green)" : "#888"}
            />
            <span style={{ ...styles.label, ...(active ? styles.labelActive : {}) }}>
              {label}
            </span>
            {active && <span style={styles.dot} />}
          </Link>
        );
      })}
    </nav>
  );
}

const styles = {
  nav: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    borderTop: "1px solid rgba(0,0,0,0.08)",
    background: "white",
    paddingBottom: "env(safe-area-inset-bottom)",
    zIndex: 100,
  },
  tab: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "3px",
    padding: "8px 4px 6px",
    textDecoration: "none",
  },
  label: {
    fontSize: "10px",
    fontWeight: "400",
    color: "#888",
    letterSpacing: "0.01em",
  },
  labelActive: {
    fontWeight: "600",
    color: "var(--soil-green)",
  },
  dot: {
    width: "4px",
    height: "4px",
    borderRadius: "50%",
    background: "var(--soil-green)",
    marginTop: "1px",
  },
};